/**
 * A GLN (GS1 Global Location Number): 13 digits, the last one the GS1 mod-10 check digit —
 * weights 3 and 1 alternating from the right of the first 12 digits. The same rule the server
 * applies (`PurchaseOrderingConfigService.isValidGln`), checked here so a typo shows while typing.
 */
export function isValidGln(gln: string): boolean {
  if (!/^\d{13}$/.test(gln)) return false
  let sum = 0
  for (let i = 0; i < 12; i++) {
    sum += Number(gln[i]) * ((12 - i) % 2 === 1 ? 3 : 1)
  }
  return (10 - (sum % 10)) % 10 === Number(gln[12])
}
